<template>
  <div class="products-body-container">
    <app-navbar8 logoSrc="/logo_trans-1500h.png">
      <template v-slot:link1>
        <div class="products-body-fragment10">
          <span class="products-body-text10">#home</span>
        </div>
      </template>
      <template v-slot:link2>
        <div class="products-body-fragment11">
          <span class="products-body-text11">#products</span>
        </div>
      </template>
      <template v-slot:link3>
        <div class="products-body-fragment12">
          <span class="products-body-text12">#services</span>
        </div>
      </template>
      <template v-slot:link4>
        <div class="products-body-fragment13">
          <span class="products-body-text13">#contact</span>
        </div>
      </template>
      <template v-slot:page1>
        <div class="products-body-fragment14">
          <span class="products-body-text14">Home</span>
        </div>
      </template>
      <template v-slot:page2>
        <div class="products-body-fragment15">
          <span class="products-body-text15">Products</span>
        </div>
      </template>
      <template v-slot:page3>
        <div class="products-body-fragment16">
          <span class="products-body-text16">Services</span>
        </div>
      </template>
      <template v-slot:page4>
        <div class="products-body-fragment17">
          <span class="products-body-text17">Contact</span>
        </div>
      </template>
      <template v-slot:action1>
        <div class="products-body-fragment18">
          <span class="products-body-text18">Sign In</span>
        </div>
      </template>
      <template v-slot:action2>
        <div class="products-body-fragment19">
          <span class="products-body-text19">Create</span>
        </div>
      </template>
      <template v-slot:page1Description>
        <div class="products-body-fragment20">
          <span class="products-body-text20">Page One Description</span>
        </div>
      </template>
      <template v-slot:page2Description>
        <div class="products-body-fragment21">
          <span class="products-body-text21">Page Two Description</span>
        </div>
      </template>
      <template v-slot:page3Description>
        <div class="products-body-fragment22">
          <span class="products-body-text22">Page Three Description</span>
        </div>
      </template>
      <template v-slot:page4Description>
        <div class="products-body-fragment23">
          <span class="products-body-text23">Page Four Description</span>
        </div>
      </template>
    </app-navbar8>
    <features-body
      rootClassName="features-bodyroot-class-name"
      feature1ImageSrc="/spearmintcocoa-600w.jpg"
      feature2ImageSrc="/spearmintcocoa-600w.jpg"
    >
      <template v-slot:sectionTitle>
        <div class="products-body-fragment24">
          <span class="products-body-text24">Body Butter</span>
        </div>
      </template>
      <template v-slot:feature1Title>
        <div class="products-body-fragment25">
          <span class="products-body-text25">
            <span>Spearmint Cocoa (2oz)</span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature2Title>
        <div class="products-body-fragment26">
          <span class="products-body-text28">Spearmint Cocoa (4oz)</span>
        </div>
      </template>
      <template v-slot:feature3Title>
        <div class="products-body-fragment27">
          <span class="products-body-text29">Consultations with Herbalist</span>
        </div>
      </template>
      <template v-slot:feature4Title>
        <div class="products-body-fragment28">
          <span class="products-body-text30">Gardening Services</span>
        </div>
      </template>
      <template v-slot:sectionTitle1>
        <div class="products-body-fragment29">
          <span class="products-body-text31">
            <span>*organic</span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature1Button>
        <div class="products-body-fragment30">
          <span class="products-body-text34">Buy 2oz ($15.00)</span>
        </div>
      </template>
      <template v-slot:feature2Button>
        <div class="products-body-fragment31">
          <span class="products-body-text35">Buy 4oz ($25.00)</span>
        </div>
      </template>
      <template v-slot:feature3Button>
        <div class="products-body-fragment32">
          <span class="products-body-text36">Book Consultation</span>
        </div>
      </template>
      <template v-slot:feature4Button>
        <div class="products-body-fragment33">
          <span class="products-body-text37">
            Learn More about Gardening Services
          </span>
        </div>
      </template>
      <template v-slot:sectionTitle11>
        <div class="products-body-fragment34">
          <span class="products-body-text38">
            <span>A blend of organic oils and butters.</span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature1Description>
        <div class="products-body-fragment35">
          <span class="products-body-text41">
            <span>
              *cocoa butter, *shea butter, *coconut oil, *rosehip oil, vitamin E
              oil, spearmint and cocoa essential oils
              <span v-html="raw9615"></span>
            </span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature2Description>
        <div class="products-body-fragment36">
          <span class="products-body-text44">
            *cocoa butter, *shea butter, *coconut oil, *rosehip oil, vitamin E
            oil, spearmint and cocoa essential oils
          </span>
        </div>
      </template>
      <template v-slot:feature3Description>
        <div class="products-body-fragment37">
          <span class="products-body-text45">
            Get personalized advice and recommendations from our expert herbalist.
          </span>
        </div>
      </template>
      <template v-slot:feature4Description>
        <div class="products-body-fragment38">
          <span class="products-body-text46">
            Let us help you create your own herbal garden for a sustainable
            wellness lifestyle.
          </span>
        </div>
      </template>
    </features-body>
    <app-footer4 rootClassName="footer4root-class-name4">
      <template v-slot:termsLink>
        <div class="products-body-fragment39">
          <span class="products-body-text47">Terms of Service</span>
        </div>
      </template>
      <template v-slot:cookiesLink>
        <div class="products-body-fragment40">
          <span class="products-body-text48">Cookies Settings</span>
        </div>
      </template>
      <template v-slot:privacyLink>
        <div class="products-body-fragment41">
          <span class="products-body-text49">Privacy Policy</span>
        </div>
      </template>
    </app-footer4>
  </div>
</template>

<script>
import AppNavbar8 from '../components/navbar8'
import FeaturesBody from '../components/features-body'
import AppFooter4 from '../components/footer4'

export default {
  name: 'ProductsBody',
  props: {},
  components: {
    AppNavbar8,
    FeaturesBody,
    AppFooter4,
  },
  data() {
    return {
      raw9615: ' ',
    }
  },
  metaInfo: {
    title: 'Products-Body - Wildwood Herbs',
    meta: [
      {
        property: 'og:title',
        content: 'Products-Body - Wildwood Herbs',
      },
    ],
  },
}
</script>

<style scoped>
.products-body-container {
  width: 100%;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
 
.products-body-fragment10 {
  display: contents;
}
 
.products-body-text10 {
  display: inline-block;
}
 
.products-body-fragment11 {
  display: contents;
}
 
.products-body-text11 {
  display: inline-block;
}
 
.products-body-fragment12 {
  display: contents;
}
 
.products-body-text12 {
  display: inline-block;
}
 
.products-body-fragment13 {
  display: contents;
}
 
.products-body-text13 {
  display: inline-block;
}
 
.products-body-fragment14 {
  display: contents;
}
 
.products-body-text14 {
  display: inline-block;
}
 
.products-body-fragment15 {
  display: contents;
}
 
.products-body-text15 {
  display: inline-block;
}
 
.products-body-fragment16 {
  display: contents;
}
 
.products-body-text16 {
  display: inline-block;
}
 
.products-body-fragment17 {
  display: contents;
}
 
.products-body-text17 {
  display: inline-block;
}
 
.products-body-fragment18 {
  display: contents;
}
 
.products-body-text18 {
  display: inline-block;
}
 
.products-body-fragment19 {
  display: contents;
}
 
.products-body-text19 {
  display: inline-block;
}
 
.products-body-fragment20 {
  display: contents;
}
 
.products-body-text20 {
  display: inline-block;
}
 
.products-body-fragment21 {
  display: contents;
}
 
.products-body-text21 {
  display: inline-block;
}
 
.products-body-fragment22 {
  display: contents;
}
 
.products-body-text22 {
  display: inline-block;
}
 
.products-body-fragment23 {
  display: contents;
}
 
.products-body-text23 {
  display: inline-block;
}
 
.products-body-fragment24 {
  display: contents;
}
 
.products-body-text24 {
  display: inline-block;
}
 
.products-body-fragment25 {
  display: contents;
}
 
.products-body-text25 {
  display: inline-block;
}
 
.products-body-fragment26 {
  display: contents;
}
 
.products-body-text28 {
  display: inline-block;
}
 
.products-body-fragment27 {
  display: contents;
}
 
.products-body-text29 {
  display: inline-block;
}
 
.products-body-fragment28 {
  display: contents;
}
 
.products-body-text30 {
  display: inline-block;
}
 
.products-body-fragment29 {
  display: contents;
}
 
.products-body-text31 {
  display: inline-block;
}
 
.products-body-fragment30 {
  display: contents;
}
 
.products-body-text34 {
  display: inline-block;
}
 
.products-body-fragment31 {
  display: contents;
}
 
.products-body-text35 {
  display: inline-block;
}
 
.products-body-fragment32 {
  display: contents;
}
 
.products-body-text36 {
  display: inline-block;
}
 
.products-body-fragment33 {
  display: contents;
}
 
.products-body-text37 {
  display: inline-block;
}
 
.products-body-fragment34 {
  display: contents;
}
 
.products-body-text38 {
  display: inline-block;
}
 
.products-body-fragment35 {
  display: contents;
}
 
.products-body-text41 {
  display: inline-block;
}
 
.products-body-fragment36 {
  display: contents;
}
 
.products-body-text44 {
  display: inline-block;
}
 
.products-body-fragment37 {
  display: contents;
}
 
.products-body-text45 {
  display: inline-block;
}
 
.products-body-fragment38 {
  display: contents;
}
 
.products-body-text46 {
  display: inline-block;
}
 
.products-body-fragment39 {
  display: contents;
}
 
.products-body-text47 {
  display: inline-block;
}
 
.products-body-fragment40 {
  display: contents;
}
 
.products-body-text48 {
  display: inline-block;
}
 
.products-body-fragment41 {
  display: contents;
}
 
.products-body-text49 {
  display: inline-block;
}
</style>
